
const templates = [
    {
        name: "@system/mobile/pages/messages/simple-notify",
        loader: () => import("./components/MessageViewer/SimpleNotify"),
        pure: true,
    },
    {
        name: "@system/mobile/addons/messages/tabbar-badge-message-observer",
        loader: () => import("./components/addons/TabBarBadgeMessageObserver"),
        pure: true,
    },
];

export default templates;